export const STYLES = {
   paddingTopStyle: {paddingTop: '65px'},
}



// WEBPACK FOOTER //
// ./src/components/Modal/model_styles.js